
(function () {
  'use strict';

function trackBabyBoxUpsell(eventName, data) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, data || {});
  }
}

  function closeUpsell() {
    var overlay = document.getElementById('babybox-upsell-modal');
    if (overlay) overlay.remove();
  }

  function makeElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }

  function openUpsell(data) {
    if (!data || document.getElementById('babybox-upsell-modal')) return;

    var products = data.querySelectorAll('[data-upsell-product]');
    if (!products.length) return;

    var overlay = makeElement('div', 'babybox-upsell-overlay');
    overlay.id = 'babybox-upsell-modal';

    var modal = makeElement('div', 'babybox-upsell-modal');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Complete Their Gift');

    var close = makeElement('button', 'babybox-upsell-close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.addEventListener('click', closeUpsell);
    modal.appendChild(close);

    var header = makeElement('div', 'babybox-upsell-header');
header.appendChild(makeElement('h2', '', 'Complete Their Gift ♡'));
header.appendChild(makeElement(
  'p',
  '',
  'EXCLUSIVE 10% OFF – Add an extra gift and save!'
));
modal.appendChild(header);

    Array.prototype.slice.call(products, 0, 3).forEach(function (product) {
      var item = makeElement('div', 'babybox-upsell-item');

      var image = product.querySelector('img');
      if (image) {
        var imageCopy = image.cloneNode(true);
        imageCopy.className = 'babybox-upsell-image';
        item.appendChild(imageCopy);
      }

      var details = makeElement('div', 'babybox-upsell-details');

      details.appendChild(makeElement(
        'h3',
        'babybox-upsell-product-title',
        product.getAttribute('data-product-title') || ''
      ));

      var originalPrice = product.querySelector('.babybox-upsell-price');

var price = makeElement('div', 'babybox-upsell-product-price');

var oldPrice = makeElement('span', 'babybox-upsell-old-price');
var newPrice = makeElement('span', 'babybox-upsell-new-price');
var saving = makeElement('span', 'babybox-upsell-saving');

price.appendChild(oldPrice);
price.appendChild(newPrice);
price.appendChild(saving);
details.appendChild(price);

function updateUpsellPrice(priceText) {
  var amount = parseFloat(
    String(priceText || '').replace(/[^0-9.]/g, '')
  );

  if (!isFinite(amount)) {
    oldPrice.textContent = '';
    newPrice.textContent = priceText || '';
    saving.textContent = '';
    return;
  }

  var originalPence = Math.round(amount * 100);
  var discountedPence = Math.round(originalPence * 0.9);
  var savedPence = originalPence - discountedPence;

  oldPrice.textContent = '£' + (originalPence / 100).toFixed(2);
  newPrice.textContent = '£' + (discountedPence / 100).toFixed(2);
  saving.textContent = '10% OFF – Save £' + (savedPence / 100).toFixed(2);
}

updateUpsellPrice(
  originalPrice ? originalPrice.textContent.trim() : ''
);

      var variantSource = product.querySelector('[data-upsell-variant]');
      var variants = variantSource
        ? Array.prototype.slice.call(variantSource.options)
        : [];

      var variantLabel = makeElement('label', 'babybox-upsell-label', 'Size / Option');
      var variantSelect = makeElement('select', 'babybox-upsell-select');
      variantSelect.setAttribute('aria-label', 'Choose size or option');

      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Choose an option';
      variantSelect.appendChild(placeholder);

      variants.forEach(function (variant) {
  var option = document.createElement('option');
  option.value = variant.value;

  var variantTitle = variant.textContent.trim();

  // Display the final part of a combined variant name.
  // Example: "Personalised Spidey Robe / 3-4 Years"
  // becomes "3-4 Years".
  if (variantTitle.indexOf(' / ') !== -1) {
    variantTitle = variantTitle.split(' / ').pop().trim();
  }

  option.textContent = variantTitle;
        option.setAttribute(
          'data-price',
          variant.getAttribute('data-price') || ''
        );
        variantSelect.appendChild(option);
      });

      if (variants.length === 1 &&
          variants[0].textContent.trim().toLowerCase() === 'default title') {
        variantSelect.value = variants[0].value;
        variantLabel.style.display = 'none';
        variantSelect.style.display = 'none';
      }

      variantSelect.addEventListener('change', function () {
  var selected = variantSelect.options[variantSelect.selectedIndex];
  var selectedPrice = selected && selected.getAttribute('data-price');

  updateUpsellPrice(
    selectedPrice || (
      originalPrice ? originalPrice.textContent.trim() : ''
    )
  );
});

      details.appendChild(variantLabel);
      details.appendChild(variantSelect);

      var requiresCustomisation =
  product.getAttribute('data-requires-customisation') !== 'false';
      var customLabel = makeElement('label', 'babybox-upsell-label');
      customLabel.textContent = 'Customisation (if required) ';

      var info = makeElement('span', 'babybox-upsell-info', 'ⓘ');
      info.setAttribute('title',
        'Enter the name and/or age or number required for this item. ' +
        'Examples: Oliver, 4, or Oliver 4. ' +
        'Check spelling carefully. Leave blank if not required.'
      );
      info.setAttribute('tabindex', '0');
      customLabel.appendChild(info);
      details.appendChild(customLabel);

      var customInput = makeElement('input', 'babybox-upsell-input');
      customInput.type = 'text';
      customInput.placeholder = 'e.g. Oliver / Oliver 4';
      customInput.maxLength = 100;
      customInput.setAttribute('aria-label', 'Customisation');
      details.appendChild(customInput);
      if (!requiresCustomisation) {
  customLabel.style.display = 'none';
  customInput.style.display = 'none';
}

      if (requiresCustomisation) {
  details.appendChild(makeElement(
    'p',
    'babybox-upsell-help',
    'Enter the name, age or number required. Please check spelling carefully.'
  ));
}

      var feedback = makeElement('p', 'babybox-upsell-feedback');
      feedback.setAttribute('role', 'status');
      feedback.setAttribute('aria-live', 'polite');

      var addButton = makeElement(
        'button',
        'babybox-upsell-add',
        'Add to Basket +'
      );
      addButton.type = 'button';

      addButton.addEventListener('click', function () {
        var variantId = variantSelect.value;

        if (!variantId) {
          feedback.textContent = 'Please select a size or option.';
          feedback.className = 'babybox-upsell-feedback is-error';
          variantSelect.focus();
          return;
        }

        var customisation = customInput.value.trim();

        if (requiresCustomisation && !customisation) {
  feedback.textContent = 'Please enter your customisation.';
  feedback.className = 'babybox-upsell-feedback is-error';
  customInput.focus();
  return;
}

        
var itemData = {
  id: Number(variantId),
  quantity: 1,
  properties: {
    '_Upsell Source': 'Complete Their Gift'
  }
};

if (customisation) {
  itemData.properties.Customisation = customisation;
}


        addButton.disabled = true;
        addButton.textContent = 'Adding...';
        feedback.textContent = '';

        window.jQuery.ajax({
          url: (window.Shopify && Shopify.routes
            ? Shopify.routes.root : '/') + 'cart/add.js',
          method: 'POST',
          dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify(itemData),
          babyboxUpsellAdd: true
        }).done(function () {
          addButton.textContent = '✓ Added to Basket';
          feedback.textContent = 'Added successfully!';
          feedback.className = 'babybox-upsell-feedback is-success';

          // Keep this button disabled to avoid accidental duplicate adds.
          // Refresh cart count where the theme supports the event.
          window.jQuery(document.body).trigger('babybox:upsell-added');
          

trackBabyBoxUpsell('babybox_upsell_added', {
  variant_id: Number(variantId),
  currency: 'GBP',
  value: Number(
    (function () {
      var selectedOption = variantSelect.options[variantSelect.selectedIndex];
      var priceText = selectedOption.getAttribute('data-price') || '';
      var price = priceText.replace(/[^0-9.]/g, '');
      return price || '0';
    })()
  )
});


        }).fail(function (xhr) {
          var message = 'Could not add this item. Please try again.';
          if (xhr.responseJSON &&
              xhr.responseJSON.description &&
              typeof xhr.responseJSON.description === 'string') {
            message = xhr.responseJSON.description;
          }
          feedback.textContent = message;
          feedback.className = 'babybox-upsell-feedback is-error';
          addButton.disabled = false;
          addButton.textContent = 'Add to Basket +';
        });
      });

      details.appendChild(addButton);
      details.appendChild(feedback);
      item.appendChild(details);
      modal.appendChild(item);
    });

    var footer = makeElement('div', 'babybox-upsell-footer');

    var continueButton = makeElement(
      'button',
      'babybox-upsell-continue',
      'No thanks, continue shopping'
    );
    continueButton.type = 'button';
    continueButton.addEventListener('click', closeUpsell);

    var cartLink = makeElement('a', 'babybox-upsell-cart', 'View Basket');
    cartLink.href = '/cart';

    footer.appendChild(continueButton);
    footer.appendChild(cartLink);
    modal.appendChild(footer);

    overlay.appendChild(modal);

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeUpsell();
    });

    document.body.appendChild(overlay);
    
trackBabyBoxUpsell('babybox_upsell_viewed');

  }

  function initialiseUpsell() {
    if (!window.jQuery) {
      setTimeout(initialiseUpsell, 100);
      return;
    }

    window.jQuery(document)
      .off('ajaxSuccess.babyboxUpsell')
      .on('ajaxSuccess.babyboxUpsell', function (event, xhr, settings) {
        if (settings.babyboxUpsellAdd) return;

        var url = settings && settings.url ? settings.url : '';

        if (!/\/cart\/add(?:\.js)?(?:\?|$)/.test(url)) return;

        var data = document.querySelector('[data-babybox-upsell]');

        if (!data || !data.querySelector('[data-upsell-product]')) {
          return;
        }

        setTimeout(function () {
          openUpsell(data);
        }, 400);
      });

    console.log('Baby Box upsell ready');
  }

  initialiseUpsell();
})();
